//NPM LIBRARIES
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import AUDirectionLink from '@gov.au/direction-links';
import { useDispatch } from "react-redux";

//REDUX ACTIONS AND SELECTORS
import { getFormPropertiesSelector } from '../FormStore/Selectors/FormDataSelectors';
import { getUrlSelector } from '../PortalStore/Selectors/EnvDataSelectors';

//NPM LIBRARIES
import Heading from '../components/CASA/Heading';

/* DEFAULT
 * The SuccessScreen component
 *
 * @param  {object}  children  - HTML to be shown in the success message 
 */
const SuccessScreen = (props) => {
    const portalUrlSettings = useSelector(state => getUrlSelector(state, "Portal - Home URL"));

    const formProperties = useSelector(state => getFormPropertiesSelector(state.formStore));

    const organisationId = (formProperties?.orgid || props?.orgid) ?? null

    const getPortalUrl = () => {
        let portalReturnUrl = "";

        if (organisationId !== null) {
            portalReturnUrl = portalUrlSettings + '/dashorg/?casaorgid=' + organisationId;
        }
        else {
            portalReturnUrl = portalUrlSettings + '/dashind';
        }
        return portalReturnUrl;
    }

    return (
        <Fragment>
            <Heading
                id="pageheading"
                showcrumbs={false}
                showback={false} />

            <div className="successMessage">
                {props.children}
            </div>

            <AUDirectionLink link={getPortalUrl()} text="Return to myCASA" direction="left" />
        </Fragment>
    );
};

SuccessScreen.propTypes = {
    children: PropTypes.object,
    orgid: PropTypes.string 
}

export default SuccessScreen;